import { SvgIcon } from "@mui/material";

const BagIcon = () => {
  return (
    <SvgIcon width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.54186 21.5833C9.42053 21.5833 9.29686 21.5588 9.17903 21.5051C8.7392 21.3056 8.54436 20.7865 8.74503 20.3466L11.6617 13.93C11.8635 13.4901 12.3839 13.2976 12.8202 13.496C13.26 13.6955 13.4549 14.2146 13.2542 14.6545L10.3375 21.0711C10.1917 21.3931 9.8732 21.5833 9.54186 21.5833Z"
        fill="#6FCF97"
      />
      <path
        d="M8.66667 15.7503C8.02267 15.7503 7.5 15.2265 7.5 14.5837C7.5 13.9408 8.02267 13.417 8.66667 13.417C9.31067 13.417 9.83333 13.9408 9.83333 14.5837C9.83333 15.2265 9.31067 15.7503 8.66667 15.7503Z"
        fill="#6FCF97"
      />
      <path
        d="M13.3337 21.5833C12.6897 21.5833 12.167 21.0595 12.167 20.4167C12.167 19.7738 12.6897 19.25 13.3337 19.25C13.9777 19.25 14.5003 19.7738 14.5003 20.4167C14.5003 21.0595 13.9777 21.5833 13.3337 21.5833Z"
        fill="#6FCF97"
      />
      <path
        d="M13.1813 7C12.9246 7 12.6703 6.888 12.4976 6.67217C12.1954 6.29417 12.2573 5.74467 12.6341 5.4425L16.5996 2.26917C16.7338 2.16183 16.7244 2.0335 16.6941 1.94483C16.6638 1.85617 16.5926 1.75 16.4246 1.75H5.57461C5.40661 1.75 5.33544 1.855 5.30511 1.94483C5.27478 2.03467 5.26544 2.16183 5.39844 2.268L9.36511 5.4425C9.74194 5.74467 9.80378 6.29417 9.50161 6.67217C9.19944 7.05017 8.64994 7.11083 8.27078 6.80867L4.30528 3.63533C3.61928 3.08817 3.36144 2.198 3.65194 1.36733C3.94244 0.536667 4.69728 0 5.57461 0H16.4258C17.3031 0 18.0568 0.536667 18.3473 1.36617C18.6378 2.19567 18.3799 3.087 17.6928 3.63533L13.7284 6.8075C13.5663 6.937 13.3738 7 13.1813 7Z"
        fill="#1E8E1B"
      />
      <path
        d="M15.0833 28.0005H7.20833C2.57433 28.0005 0.5 24.0455 0.5 20.1255C0.5 14.6795 4.10967 7.78448 8.22333 5.37064C8.63983 5.12564 9.17533 5.26564 9.42033 5.68331C9.66533 6.09981 9.52533 6.63648 9.10883 6.88031C5.52017 8.98614 2.25 15.299 2.25 20.1255C2.25 22.9511 3.5485 26.2505 7.20833 26.2505H15.0833C19.295 26.2505 19.75 21.9676 19.75 20.1255C19.75 15.299 16.4798 8.98614 12.89 6.88031C12.4747 6.63648 12.3335 6.09981 12.5785 5.68331C12.8223 5.26681 13.3543 5.12564 13.7755 5.37064C17.8903 7.78448 21.5 14.6795 21.5 20.1255C21.5 24.9835 19.0418 28.0005 15.0833 28.0005Z"
        fill="#1E8E1B"
      />
    </SvgIcon>
  );
};

export default BagIcon;
